import connectionReducer, { configureWithStore as connectionConfigurator } from './connection-reducer';
import messagesReducer, { configureWithStore as messagesConfigurator } from './messages-reducer';
import watchlistReducer, { configureWithStore as watchlistConfigurator } from './watchlist-reducer';

import counterReducer from './counter-reducer';

export const allReducers = {
    connection: connectionReducer,
    messages: messagesReducer,
    watchlist: watchlistReducer,
    counter: counterReducer,
}

export const allConfigurators = {
    connection: connectionConfigurator,
    messages: messagesConfigurator,
    watchlist: watchlistConfigurator,
}
